export default "/assets/images/awards-celebration.gif?6d2dc50e785a9d1f1326da783b1cd591";